/** @internal */
export const OP_AND = "And";
/** @internal */
export const OP_OR = "Or";
/** @internal */
export const OP_INVALID_DATA = "InvalidData";
/** @internal */
export const OP_MISSING_DATA = "MissingData";
/** @internal */
export const OP_SOURCE_UNAVAILABLE = "SourceUnavailable";
/** @internal */
export const OP_UNSUPPORTED = "Unsupported";
//# sourceMappingURL=configError.js.map